var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoughnut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM8.8 20C8.8 26.1856 13.8144 31.2 20 31.2C26.1856 31.2 31.2 26.1856 31.2 20C31.2 13.8144 26.1856 8.8 20 8.8C13.8144 8.8 8.8 13.8144 8.8 20Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M20 0C24.2236 5.03657e-08 28.3388 1.3371 31.7557 3.81966C35.1727 6.30222 37.716 9.80279 39.0211 13.8197C40.3263 17.8365 40.3263 22.1635 39.0211 26.1803C37.716 30.1972 35.1727 33.6978 31.7557 36.1803L26.5832 29.061C28.4967 27.6708 29.9209 25.7104 30.6518 23.461C31.3827 21.2115 31.3827 18.7885 30.6518 16.539C29.9209 14.2896 28.4967 12.3292 26.5832 10.939C24.6697 9.54878 22.3652 8.8 20 8.8V0Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoughnut);
export default __webpack_public_path__ + "static/media/doughnut.aa26989289c330b2acb2306d083744be.svg";
export { ForwardRef as ReactComponent };